<template>
    <div>
        <div class="TopComStyle">
            <div class="topContainer">
                <div class="topConLeft" v-if="!LoginShowOrNot">
                    <span>欢迎，{{ orgName }}</span> | <span class="goshouye" @click="qushouye">首页</span>
                    <span class="goshouye" v-if="logintype==0" @click="toSearchList()">全局检索</span>
                    <span class="goshouye" v-if="logintype==0" @click="ComeLive()">新书推介</span>
                    <!-- <span class="goshouye" v-if="logintype==0" @click="ComeLive()">直播入口</span> -->
                    <span v-if="logintype ==1" class="goshouye" @click="qushouye">
                        <el-link type="danger" @click="qiehuan">前往旧网站</el-link>
                    </span>
                </div>
                <div class="topConLeft" v-if="LoginShowOrNot">
                    <span>游客,欢迎您</span>
                </div>
                <div class="TopConRight">
                    <template v-if="LoginShowOrNot">
                        <span @click="LoginClick()" style="cursor: pointer">立即登录！</span>
                    </template>
                    <template v-else>
                        <!-- <el-dropdown @command="handleCommand">
                                <span class="el-dropdown-link">
                                    管理后台
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="0">管理后台</el-dropdown-item>
                                    <el-dropdown-item command="1">导入馆藏</el-dropdown-item>
                                    <el-dropdown-item command="2">导入订单</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->


                        <span v-if="adminState == 0 || adminState == 1"><span @click="toManage()"
                                class="menus">管理后台</span><span>|</span></span>

                        <!-- <span><span class="menus" @click="MybookTemp()">{{adminState}}</span><span>|</span></span> -->
                        <span><span class="menus" @click="MybookTemp()">书目提取</span><span>|</span></span>
                        <!-- 0 系统管理员 1 图书馆管理员，2读者，3教师、4学生 5社会读者 -->
                        <span v-if="adminState == 0 || adminState == 1">
                            <span class="menus" @click="MyPurchaseClick('car')">我的购物车 <span class="menus"
                                    v-if="Number(GoodLengthData) > 0">({{GoodLengthData}}种) </span><span>|</span>
                            </span>
                        </span>
                        <span v-if="adminState == 0 || adminState == 1">
                            <span class="menus" @click="MyPurchaseClick('order')">我的订单</span>
                            <span>|</span>
                        </span>
                        <span v-if="adminState == 2 || adminState == 3 || adminState == 4 || adminState == 5">
                            <span class="menus" @click="myrecommendedpurchase()">我的荐购</span><span>|</span>
                        </span>
                        <span v-if="adminState == 2 || adminState == 3 || adminState == 4 || adminState == 5">
                            <span class="menus" @click="myBorrows()">我的借阅</span><span>|</span>
                        </span>
                        <!-- <span> <span class="menus" @click="getaddressmanagement()">地址管理</span><span>|</span></span> -->
                        <span> <span class="menus" @click="MyClickTop()">访问统计</span><span>|</span></span>
                        <!-- <span>欢迎，{{ orgName }}</span> -->
                        <el-dropdown @command="selfHandleCommand">
                            <span class="el-dropdown-link">{{ name}}<i
                                    class="el-icon-arrow-down el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="0">修改密码</el-dropdown-item>
                                <el-dropdown-item v-if="logintype ==1" command="1">修改个人信息</el-dropdown-item>
                                <el-dropdown-item command="2"
                                    v-if="isdirectmail && logintype ==1">地址管理</el-dropdown-item>
                                <el-dropdown-item command="3">退出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Dropdown, DropdownMenu, DropdownItem } from "element-ui";
    import Cookies from "js-cookie";
    import popup from "../../common/plugin/dialog/index";
    import SetPassword from "../../components/setPassWord.vue";
    import ImproveInfo from "../../components/improveInfo.vue";
    import Axios from "@/api/diyaxios";
    import { shoppingCartnum, isRmdPost } from "@/api/pages";
    import { getUserInfo, getUserId } from "@/common/utils/user_info";
    import Vue from 'vue'
    import { vueBaberrage, MESSAGE_TYPE } from 'vue-baberrage';
    import tidyRules from "clean-css/lib/optimizer/level-1/tidy-rules";
    import { turquoise } from "color-name";
    Vue.use(vueBaberrage)


    export default {
        name: "TopComponent",
        props: ['datalogintype'],
        data() {
            return {
                // name:JSON.parse(localStorage.getItem('user')).userName,
                maxWordCount: 3,
                barrageList: [],
                isAble: false, //禁用按钮
                content: {},
                arrDate: [], // 当月签到日期
                timeDay: "",
                errorMsg: "",
                success: "",
                // adminState: Cookies.get("adminState"),
                isdirectmail: false,
                logintype: Cookies.get('logintype'),
            };
        },
        components: {
            Dropdown,
            DropdownMenu,
            DropdownItem,
        },
        watch: {},
        created() {
            // this.getWinningRecord()
            // this.getJindan()
            this.logintype = this.datalogintype;
        },
        computed: {
            // 获取名字
            name() {
                return this.$store.state.DataStorage.name || Cookies.get('name')
            },
            adminState() {
                return Number(this.$store.state.DataStorage.adminState) || Cookies.get('adminState')
            },
            // 获取图书馆机构gid
            orgGid() {
                return this.$store.state.DataStorage.orgGid || Cookies.get('orgGid')
            },
            // 获取图书馆名字
            orgName() {
                return this.$store.state.DataStorage.orgName || Cookies.get('orgName')
            },
            GoodLengthData() {
                return this.$store.state.DataStorage.GoodLengthData;
                // return 100
            },
            // 登录成功之后的标识
            LoginShowOrNot() {
                return this.$store.state.DataStorage.LoginShowOrNot;
            },
        },
        mounted() {
            let vm = this
            // vm.mysource()

            vm.logintype = Cookies.get('logintype')
            if (Cookies.get("token")) {
                vm.$store.state.DataStorage.LoginShowOrNot = false;
                vm.getShopCarData();
            }
            if (vm.$route.name === "calendar") {
                vm.isAble = true;
            }
            //用户权限
            let user = JSON.parse(localStorage.getItem('user'));
            if (user) {
                isRmdPost({ orgGid: user.orgGid, userId: user.gid }).then(res => {
                    if (res.code == '200') {
                        vm.isdirectmail = res.data.data.isdirectmail;
                        localStorage.setItem('roleInfo', JSON.stringify(res.data.data));
                        if (res.data.data.iscompleteuser) {
                            vm.showInproveInfoPop('请先完善个人信息，才能进行荐购！', false);
                        }
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                            duration: 5 * 1000
                        });
                    }
                });
            }
        },
        watch: {},

        methods: {
            //     mysource1(){
            //      Cookies.set('logintype', 1)
            // },
            //完善个人资料
            showInproveInfoPop(title, isShowClose) {
                let vm = this;
                vm.info = popup('<improve-info @submit="submit" @close="close"></improve-info>', {
                    option: {
                        title: title,// "请先完善个人信息",
                        width: "490px",
                        showClose: isShowClose,
                    },
                    popup: {
                        data() {
                            return {};
                        },
                        components: {
                            ImproveInfo,
                        },
                        methods: {
                            submit(data) {
                                // vm.name = data; //同步更新名称
                                vm.info.hide();
                            },
                            close() {
                                vm.info.hide();
                            }
                        }
                    }
                });
                vm.info.show();
            },
            qiehuan() {
                window.open("http://y.sanxinbook.com/#/");

            },
            qushouye() {
                if (this.logintype == 0) {
                    this.$router.push({ name: "HomePage" });
                } else {
                    this.$router.push({ name: "Xindex" });
                }

            },
            // 展示购物车数据
            async getShopCarData() {
                let data = {
                    userId: Cookies.get("UserID"),
                    source: Cookies.get("source")
                };
                let res = await shoppingCartnum(data)
                if (res.code == '200') {
                    this.$store.state.DataStorage.GoodLengthData = res.data;
                }
            },
            MybookTemp() {
                const router = this.$router.resolve({
                    path: '/getBook',
                })
                window.open(router.href)
                // this.$router.push({ name: "getBook" });
            },
            MyClickTop() {
                const router = this.$router.resolve({
                    path: '/Statistical',
                })
                window.open(router.href)
                // this.$router.push({ name: "Statistical" });
            },
            // 地址管理
            getaddressmanagement() {
                const router = this.$router.resolve({
                    path: '/addressmanagement',
                })
                window.open(router.href)
            },
            //点击事件
            MyPurchaseClick(type) {
                if (type === "homepage") {
                    const router = this.$router.resolve({
                        path: '/HomePage',
                    })
                    window.open(router.href)
                    // this.$router.push({ name: "HomePage" });
                }
                if (type === "car") {
                    const router = this.$router.resolve({
                        path: '/MyPurchase',
                    })
                    window.open(router.href)

                    // this.$router.push({ name: "MyPurchase" });
                } else if (type === "order") {
                    const router = this.$router.resolve({
                        path: '/OrderOver',
                    })
                    window.open(router.href)
                    // this.$router.push({ name: "OrderOver" });
                }
            },
            myrecommendedpurchase() {
                const router = this.$router.resolve({
                    path: '/myRmdList',
                })
                window.open(router.href)
                // this.$router.push({ name: "myRmdList" });
            },
            //我的借阅
            myBorrows() {
                const router = this.$router.resolve({
                    path: '/myBorrowRecord',
                })
                window.open(router.href)
            },
            // 登录
            LoginClick() {
             const currentBaseId = this.$route.params.baseid || Cookies.get('orgCode');
             this.$router.push({ name: "Login", params: { baseid: currentBaseId } });
            },
            selfHandleCommand(command) {
                let vm = this;
                // 获取当前机构GID，保证退出/改密码后依然锁定
                const currentBaseId = vm.$route.params.baseid || Cookies.get('orgCode');

                if (Cookies.get("token")) {
                    if (command == "0") {
                        //修改密码
                        vm.uppass = popup(
                            '<Set-password @ok="submit" @close ="close"></Set-password >',
                            {
                                option: {
                                    title: "修改密码",
                                    width: "490px",
                                },
                                popup: {
                                    data() {
                                        return {};
                                    },
                                    components: {
                                        SetPassword,
                                    },
                                    methods: {
                                        submit(data) {
                                            vm.uppass.hide();
                                            vm.$confirm("密码修改成功，请重新登录！", "提示", {
                                                confirmButtonText: "确定",
                                                showCancelButton: false,
                                                showClose: false,
                                                center: true,
                                                callback: (action) => {
                                                    vm.TuiClick();
                                                    // 👇 关键：带机构跳转
                                                    vm.$router.push({ name: "Login", params: { baseid: currentBaseId } });
                                                },
                                            });
                                        },
                                        close(data) {
                                            vm.uppass.hide();
                                        },
                                    },
                                },
                            }
                        );
                        vm.uppass.show();
                    } else if (command == "1") {
                        vm.showInproveInfoPop('修改个人信息', true);
                    } else if (command == "2") {
                        vm.getaddressmanagement();
                    } else if (command == "3") {
                        //退出
                        vm.$confirm("确定要退出吗？", "提示", {
                            confirmButtonText: "确定",
                            cancelButtonText: "取消",
                            type: "warning",
                        }).then(() => {
                            vm.TuiClick();
                            // jxufe CAS 机构：本地退出同时新开标签页通知 CAS 服务端注销（单点注销）
                            if (Cookies.get('loginInstitutionId') === '93594341819100163724492670182846') {
                                Cookies.remove('loginInstitutionId');
                                window.open('https://ssl.jxufe.edu.cn/cas/logout?service=https://www.sanxinbook.com', '_blank');
                            }
                            // 👇 关键：带机构跳转（本地跳登录页）
                            vm.$router.push({ name: "Login", params: { baseid: currentBaseId } });
                        }).catch(() => { });
                    }
                } else {
                    // 未登录也带机构跳转
                    this.$router.push({ name: "Login", params: { baseid: currentBaseId } });
                }
            },
            //点击退出
            TuiClick() {
                Cookies.remove("token");
                Cookies.remove("name");
                Cookies.remove("orgName");
                Cookies.remove("UserID");
                Cookies.remove("orgGid");
                Cookies.remove("passWord");
                Cookies.remove("passPort");
                Cookies.remove("source");
                Cookies.remove('logintype')
                this.$store.commit('DataStorage/clearUserInfo')
                //清除本地缓存
                localStorage.removeItem("doId");
                localStorage.removeItem("user");
                localStorage.removeItem("roleInfo");
                localStorage.removeItem("showjigou");
                localStorage.removeItem("logintype");
                localStorage.removeItem("pageUrl");
                // localStorage.clear();
                // localStorage.removeItem("source");
            },
            // 进入直播
            ComeLive() {
                // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
                // 2、HomePage: true; 用来判断是不是从首页进入的，
                // 首页进来的话，优先播放和服务器时间对的上的直播，
                // 其次是查看有没有默认直播，
                // 上面都没有满足的话就展示没有直播提醒的提示
                // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
                // this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
                // Cookies.set('HomePage', true)
                // Cookies.set('playType', 1)
                // Cookies.set('playUrl', 'null')
                // window.location.href = 'http://www.cxznlibwx.com:8090'; http://www.cxznlibwx.com:8090
                window.open('http://www.cxznlibwx.com:8090/home/sxtchzbindex', '_blank');
            },
            toSearchList() {
                if (Cookies.get("token")) {
                    // this.$router.push({ name: 'SearchResult'})
                    const router = this.$router.resolve({
                        path: '/LookPublishingPagesType',
                        query: { obj: JSON.stringify({ modeChange: 2, gid: 0 }) }
                    })
                    window.open(router.href)
                    // this.$router.push({
                    //     name: "LookPublishingPagesType",
                    //     query: { obj: JSON.stringify({ modeChange: 2, gid: 0 }) },
                    // });
                } else {
                    this.$router.push({ name: "Login" });
                }
            },
            toManage() {
                if (Cookies.get("token")) {
                    this.$router.push({
                        name: "Xht",
                    });
                } else {
                    this.$router.push({ name: "Login" });
                }
                // window.open(
                //     `http://rmdman.ytzhihui.com/#/login?passPort=${Cookies.get(
                //         "passPort"
                //     )}&orgGid=${Cookies.get("orgGid")}&passWord=${Cookies.get(
                //         "passWord"
                //     )}`
                // );
            },
            //客户问题反馈
            // ProblemReport() {
            //     if (Cookies.get("token")) {
            //         this.$router.push({ name: "ProblemReport" });
            //     } else {
            //         this.$router.push({ name: "Login" });
            //     }
            // },
            handleCommand(command) {
                if (Cookies.get("token")) {
                    if (command == "0") {
                        // this.toManage();
                        this.$router.push({ name: "Xht" });
                    } else if (command == "1") {
                        this.$router.push({ name: "ImportCol" });
                    } else if (command == "2") {
                        this.$router.push({ name: "ImportOrder" });
                    }
                } else {
                    this.$router.push({ name: "Login" });
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .TopComStyle {
        position: relative;
        height: 35px;
        /* height: 60px; */
        width: 100%;
        box-shadow: undefined, inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);
        /* background-color: #F9F9F9; */
        background-color: #fff;

        .qiandao {
            position: fixed;
            display: flex;
            flex-direction: column;
            align-items: center;
            right: 200px;
            margin-top: 50px;
            cursor: pointer;

            // z-index: 2;
            .daka {
                font-size: 25px;
            }
        }

        .el-dropdown {
            cursor: pointer;
        }
    }

    .topContainer {
        width: 1200px;
        height: 100%;
        margin: 0px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: white;
    }

    /* 1 */
    .topConLeft {
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 17px;
        cursor: pointer;
    }

    .topConLeft img {
        width: 150px;
        height: 55px;
    }

    .topConLeft span {
        cursor: pointer;
        color: #666;
        font-size: 14px;
        /* font-size: 16px; */

        line-height: 30px;
    }

    .topConLeft span.cur {
        // color: #fb7d0f;
        border-bottom: 3px solid #fb7d0f;
    }

    /* 2 */
    .el-input {
        width: 250px;
        text-align: left;
        font-family: PingFangSC-Regular;
    }

    .topContainer>>>.el-input__inner {
        color: rgba(0, 0, 0, 0.25);
        font-size: 14px;
    }

    /* 3 */
    .TopConRight {
        color: black;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
    }

    .TopConRight>span {
        // margin-left: 15px;
    }

    .q {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .r {
            margin: 0 auto;
        }

        .r div {
            width: 375px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: yellowgreen;
            border: 1px solid #000;
            font-size: 20px;
        }

        // .zjdBox {
        //     width: 500px;

        //     background-color: #fff;
        // }

        .hdcc {
            width: 200px;
            height: 40px;
            background-color: #63000f;
            border-radius: 40px;
            font-size: 20px;
            line-height: 40px;
            margin-top: 40px;
            margin-left: 40px;

            text-align: center;
        }

        .prInfo {
            position: absolute;
            bottom: 300px;
            right: 2px;
            width: 275px;
            height: 320px;
            //  background-color: #540614;
        }

        .prInfo-info {
            width: 150px;
            height: 30px;
            background-color: #63000f;
            border-radius: 30px;
            margin: 0 auto;
            margin-bottom: 5px;

            line-height: 30px;
            text-align: center;

        }

        .notice {
            width: 270px;
            height: 300px;
            border-radius: 8px;
            // border: 1px solid #eee;

        }

        .notice__inner {
            width: 100%;
            height: 100%;
            overflow: hidden;
            font-size: 14px;
            color: #999;
        }

        .notice__box {
            animation: roll 2s linear infinite;
        }

        .notice__item {
            width: 100%;
            height: 100px;
            line-height: 100px;
            padding: 0 12px;
            overflow: hidden;
            text-align: center;
            white-space: nowrap;
        }

        @keyframes roll {
            0% {
                transform: translatey(0);
            }

            100% {
                transform: translatey(-300px);
            }
        }

        .zjdtime {
            font-size: 24px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .hdcc1 {
            width: 342px;
            height: 440px;
            margin-left: 30px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .hdcc1 div {
            width: 342px;
            height: 40px;
            border: 1px solid #fff;
            line-height: 40px;
            text-align: center;
        }

        .mask {
            width: 1140px;
            height: 710px;
            background: rgba(0, 0, 0, .7);
            position: fixed;
            overflow: hidden;
            z-index: 222;
            top: -90px;
            left: -320px;
        }

        .popdiv {
            position: absolute;
            left: 47%;
            top: 11%;
            margin-left: -187px;
            z-index: 226;
            width: 540px;
            height: 480px;
            // border: 1px solid #fff;
            background-color: #bd2a33;
        }

        .popbox {
            height: 42px;
            width: 42px;
            position: absolute;
            bottom: 30px;
            left: 50%;
            z-index: 999;
            margin-left: -21px;
            cursor: pointer;
        }

        .lottery-alertgx {
            -moz-border-radius: 15px;
            border-radius: 15px;
        }

        .lottery-alertgx,
        .lottery-tip {
            max-width: 100%;
            text-align: center;
            z-index: 10000;

            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%)
        }

        .lottery-alerth1 {
            font-size: 20px;
            font-weight: 400;
            color: #000;
            position: relative;
            // margin-top: 20px;
        }

        .zjdContainer {
            font-family: Avenir, Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            color: #666;
            background-color: #bd2a33;
            height: 100%;
            width: 100%;
        }

        .zjdtitle {
            position: absolute;
            top: 20px;
            width: 100%;
            text-align: center;
        }

        .myprize {
            -moz-border-radius: 20px;
            border-radius: 20px;
            padding: 8px 20px;
            color: #edd251;
            font-weight: bold;
            font-size: 18px;

            margin: auto;
            // background: #fff;
        }

        .myprizeimg {
            width: 260px;
            height: 260px;
            background-color: pink;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: 120px;
            bottom: 90px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .myprizetitle {
            position: absolute;
            bottom: 45px;
            left: -5%;
            width: 150px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-left: 200px;
        }

        .linqu {
            position: absolute;
            bottom: 0;
            left: 37%;
            width: 100px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-bottom: 1px;
            cursor: pointer;
        }

        .nostate {
            width: 500px;
            height: 100px;
            // border: 1px solid #fff;
            line-height: 100px;
            text-align: center;
            font-size: 38px;
            position: absolute;
            left: 30%;
            top: 36%;
        }

    }

    .goshouye {
        margin-left: 10px;
    }

    .goshouye:hover {
        color: #CA1A1B;
    }

    .menus {
        cursor: pointer;
        margin-right: 10px
    }

    .menus:hover {
        color: #ca1a1b;
    }
</style>


// WEBPACK FOOTER //
// src/views/Components/TopComponent.vue